/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7871947caea8b67194c7f5ef74196d2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { TeamsLogo } from './logo';
export { TeamsLogoCS } from './logo-cs';
export { TeamsIcon } from './icon';
